import { activateRuleMutation } from './__generated__/activateRuleMutation.graphql';
import {
  dataValidationRuleDetailsQuery,
  dataValidationRuleDetailsQuery$data,
} from './__generated__/dataValidationRuleDetailsQuery.graphql';
import {
  dataValidationRulesLibraryQuery,
  dataValidationRulesLibraryQuery$data,
} from './__generated__/dataValidationRulesLibraryQuery.graphql';
import { deactivateRuleMutation } from './__generated__/deactivateRuleMutation.graphql';
import {
  getConnectorsByOwnerQuery,
  getConnectorsByOwnerQuery$data,
} from './__generated__/getConnectorsByOwnerQuery.graphql';
import { validationContainerQuery } from './__generated__/validationContainerQuery.graphql';

export enum RuleItemStatus {
  INACTIVE = 'INACTIVE',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  CREATING = 'CREATING',
  RUNNING = 'RUNNING',
  INACTIVE_WITH_ERRORS = 'INACTIVE_WITH_ERRORS',
  EMPTY = '',
  ACTIVE = 'ACTIVE',
}

export const RuleItemInactiveStatuses = [
  RuleItemStatus.INACTIVE,
  RuleItemStatus.INACTIVE_WITH_ERRORS,
  RuleItemStatus.EMPTY,
] as string[];

export type RulesQuery = dataValidationRulesLibraryQuery;
export type RulesQueryData = dataValidationRulesLibraryQuery$data;
export type RulesQueryDataRuleLibraryItems =
  RulesQueryData['validationRulesLibrary'];

export type RuleDetailsQuery = dataValidationRuleDetailsQuery;
export type RuleDetailsQueryData =
  dataValidationRuleDetailsQuery$data['validationRuleDetails'];

export type ConnectorsQuery = getConnectorsByOwnerQuery;
export type Connectors = getConnectorsByOwnerQuery$data['connectors'];
export type Conenctor = Connectors[number];

export type ActivateRule = activateRuleMutation;
export type ActivateRuleVariables = activateRuleMutation['variables'];
export type ActivateRuleRule = Exclude<
  Exclude<
    activateRuleMutation['variables']['specificProperties'],
    null | undefined
  >[number],
  null | undefined
>;

export type ActivateRuleResponse = activateRuleMutation['response'];

export type DeactivateRule = deactivateRuleMutation;
export type DeactivateRuleVariables = deactivateRuleMutation['variables'];

export type ValidationContainerQuery = validationContainerQuery;
export type ValidationContainerQueryData = validationContainerQuery;
export type ValidationContainerQueryDataResponse =
  ValidationContainerQueryData['response']['validationContainers'];
